var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"play-navbar",class:{ 'play-navbar--sticky': _vm.sticky, 'play-navbar--bordered': _vm.bordered }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }